import { SelectItem, SelectLabel } from '@/components/legacy-design-system/select/select'
import { Separator } from '@/components/lemmala-design-system/separator/separator'
import { MenuItem } from '@/components/shared/submit-select/types'

type ItemProps<T extends number | string> = {
  item: MenuItem<T>
}

export const Item = <T extends number | string>({ item }: ItemProps<T>) => {
  switch (item.type) {
    case 'menuSelectItem':
      return (
        <SelectItem
          className='whitespace-nowrap'
          value={item.value.toString()}
          description={item.description}
          disabled={item.disabled}
          isPotentialSelection={item.isPotentialSelection}
        >
          {item.label}
        </SelectItem>
      )
    case 'menuLabel':
      return <SelectLabel>{item.label}</SelectLabel>
    case 'menuSeparator':
      return <Separator />
    default:
      return null
  }
}
